// extracted by mini-css-extract-plugin
export default {"wrapper":"AnFSRAOBPgqoV4ahHoWW","resetPasswordForm":"pu4ZIBL6oZ2rx0Ff1PZp"};